module.exports = __webpack_public_path__ + "static/media/Wellness02.3b6b502a.jpeg";